const Loader = ({ size = 40, color = "black" }) => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <div
        className="border-4 border-dashed rounded-full animate-spin border-t-transparent"
        style={{
          width: size,
          height: size,
          borderColor: `${color} transparent ${color} ${color}`,
        }}
      ></div>
    </div>
  );
};

export default Loader;
